//
//
//
//
//
//
//
//

import $manager from "@/Manager/04.AlarSms/ShopActivitySalesCheckOrder2.js";
import PageCreate from "@/0/components/0.comPage/01.comPageCreate";
export default {
  components: {
    "page-create": PageCreate,
  },
  data() {
    return {
      dataConfig: {

      },
    };
  },
  
  methods:{

    getManager(){
      return $manager;
    },

    getBackUrl(){
      return '/AlarSms/ShopActivitySalesCheckOrder2/End';
    },
    onSubmitSucc(dataItem,result){
      var toUrl ="/AlarSms/ShopActivitySalesCheckOrder2/End?openId=" + dataItem.OpenId;
        console.log("toUrl", toUrl);
        this.$path.to(toUrl);      
    },

  }
};
